export default {
    layout: {
        loading: 'Operación en curso',
        trading: 'Operación en curso'
    },
    footer: {
    },
    menu: {
        home: 'Inicio',
        staking: 'Matriz',
        port: 'PORT',
        internet: 'Red',
        me: 'Mi cuenta',
    },
    header: {
        selectLang: 'Seleccionar idioma',
        close: 'Cerrar',
        trading: 'Operación',
        dashboard: 'Panel de control',
        subscribeMatrix: 'Suscribirse a la matriz',
        portTaskCenter: 'Centro de tareas PORT',
        network: 'Red',
        apiBinding: 'Vinculación de API',
        gridTree: 'Árbol de red',
        account: 'Cuenta',
        documents: 'Documentación y Libro Blanco',
        personalCenter: 'Centro personal',
        language: 'Idioma'
    },
    home: {
        recently1: 'Comunidad',
        staticrewares: 'Estático',
        recentlyName: 'Libro mayor',
        recentlyInfo: 'Detalles de ganancias',
        dataUpdate: 'Actualización de datos',
        realtime: 'Tiempo real · BSC',
        totalRevenue: 'Ganancias totales (USDT)',
        today: 'Hoy',
        totalTradingVolume: 'Volumen total de operaciones',
        todayEarn: 'Ganado hoy',
        share: 'Compartir con amigos',
        shareDesc: 'Comparte tus ganancias e invita para obtener recompensas',
        directReferrals: 'Referidos directos',
        teamMembers: 'Miembros del equipo',
        thisWeek: 'Esta semana',
        copy: 'Copiar',
        recently: 'Ganancias recientes',
        netIncome: 'Beneficio neto',
        dailyAverage: 'Promedio diario',
        quantitativeIncome: 'Ganancias cuantitativas',
        recommend: 'Recomendación',
        port: 'PORT',
        bonus: 'Bonificación',
        all: 'Todo',
        todayTitle: 'Hoy',
        loadingMore: 'Cargar anteriores',
        recommendBonus: 'Bonificación por recomendación',
        portTaskPassed: 'Tarea PORT completada',
        myProfit: 'Mis ganancias y pérdidas',
        earningOnBitDeep: 'Obtengo ganancias en BitDeep',
        totalRevenueUsdt: 'Ganancias totales · USDT',
        consecutiveDays: 'Días consecutivos',
        scanToJoin: 'Escanear para unirse',
        uid: 'UID',
        referralBonus: 'Bonificación por recomendación',
        shareTo: 'Compartir en',
        eachReferral: 'Recompensa por compartir',
        screenshotAndShare: 'Capturar pantalla y compartir',
        saveShareEarn: 'Guardar · Compartir · Ganar recompensas',
        period: 'Período',
        netProfit: 'Beneficio neto',
        quantReward: 'Recompensa cuantitativa',
        dailyBonus: 'Recompensa diaria de PORT',
        close: 'Cerrar',
        permission: 'Permiso',
        onlyEnable: 'Solo habilitar',
        enterBitgetUid: 'Introduzca el UID de Bitget',
        slogan: 'Código',
        document: 'Documento',
        days: 'días',
        taskText: 'Tarea',
        minutes: 'minutos',
        decentralizedPortTech: 'Arquitectura tecnológica descentralizada de PoRT, tokenómica de BGB y matriz de incentivos de doble zona.',
        auditReport: 'Informe de auditoría',
        faqSupport: 'Preguntas frecuentes y soporte',
        telegram: 'Telegram',
        piece: 'unidad',
        faq: 'Preguntas frecuentes',

        faq1: '¿Cómo vincular la API de Bitget?',
        faq1Desc: 'Accede al exchange Bitget → Configuración → Gestión de API para obtener la API Key y el Secret. Activa únicamente el permiso de trading al contado y nunca el permiso de retiro. Pega las claves en BitDeep DApp y realiza una operación de prueba de 1 U para activar la cuenta.',

        faq2: '¿Qué es PoRT (Prueba de Operación Real)?',
        faq2Desc: 'PoRT es el mecanismo principal de "minería mediante operaciones". Cada día, mediante la API de Bitget, el sistema ejecuta automáticamente compras y ventas rápidas del activo designado (como BGB). Una vez que el volumen de operaciones supera el 50 % del depósito en garantía, el sistema verifica la actividad y libera la recompensa diaria.',

        faq3: '¿Es necesario supervisar el mercado manualmente todos los días?',
        faq3Desc: 'No. Después de vincular la API, el sistema completa automáticamente las tareas de trading dentro de una ventana de 24 horas. No se requiere ninguna intervención manual; el estado puede consultarse en el menú PoRT.',

        faq4: '¿Cuál es la diferencia entre ALPHA y SIGMA?',
        faq4Desc: 'ALPHA (Básico): depósito de 500 U, rentabilidad diaria del 0,3 % al 1,3 %, limitado a un paquete. SIGMA (Profesional): depósito de 1.000 U, rentabilidad diaria del 0,6 % al 1,6 %, hasta cinco paquetes.',

        faq5: '¿Está seguro mi dinero? ¿La plataforma puede mover mis fondos?',
        faq5Desc: 'El 100 % de los fondos permanece en tu propia cuenta de Bitget. La API solo tiene permisos de lectura y trading al contado; la plataforma no puede retirar ni transferir tu capital.',

        faq6: '¿Cuándo se liquidan las ganancias diarias?',
        faq6Desc: 'Una vez aprobada la verificación PoRT, las ganancias se liquidan al día siguiente y el sistema distribuye automáticamente las recompensas en USDT y los puntos Deep ×10.',

        faq7: '¿Cómo se calcula la recompensa por recomendación?',
        faq7Desc: 'Por cada cuenta válida recomendada recibirás una recompensa fija diaria: 1 USDT/día por una cuenta ALPHA (500 U) y 2 USDT/día por una cuenta SIGMA (1.000 U), hasta que finalice el ciclo de dicha cuenta.',

        faq8: '¿Cómo se asciende de nivel (D1–D7)?',
        faq8Desc: 'El nivel aumenta según el volumen total del área menor. Por ejemplo: D1 requiere 2.000 U, D3 requiere 15.000 U y D7 requiere 3.000.000 U. Cuanto mayor sea el nivel, mayor será la recompensa diferencial (hasta 7 U por persona al día en D7).',

        faq9: '¿Cuántos días dura un ciclo? ¿Qué ocurre al finalizar?',
        faq9Desc: 'Cada ciclo dura 28 días. Al finalizar, puedes optar por renovar el depósito en garantía. Las ganancias seguirán distribuyéndose diariamente según el resultado real de la verificación PoRT.',

        faq10: '¿Hay comisión por retirar fondos?',
        faq10Desc: 'No hay comisión por retiro. Los costes de retiro son asumidos por la plataforma y se destinan al fondo de liquidez (LP), fortaleciendo el ecosistema.',

        bigArea: 'Área grande',
        smallArea: 'Área pequeña',
        enterWithdrawAmount: 'Introduzca el importe del retiro',
        available: 'Disponible',
        totalAmount: 'Importe total',
        confirmWithdraw: 'Confirmar retiro',
        withdrawRecord: 'Historial de retiros',
        withdrawn: 'Retirado',
        quickStartGuide: 'Guía de inicio rápido',
        whitepaperGuide: 'Libro Blanco y guía',
        whitepaper: 'Libro Blanco',
        downloadPdf: 'Descargar'
    },
        staking: {
        selectPackage: 'Suscribirse a la matriz',
        alpha: 'ALPHA',
        beginner: 'Principiante',
        sigma: 'SIGMA',
        professional: 'Profesional',
        popular: 'Más popular',
        dailyReturn: 'Recompensas por tarea',
        teamDepth: 'Profundidad del equipo',
        limitPurchase: 'Límite de compra',
        layer: 'Niveles',
        copy: 'unidad(es)',
        autoRenew: 'Renovación automática al vencimiento',
        autoReinvest: 'Margen de renovación automática',
        subscribeAlpha: 'Suscribirse a Alpha',
        subscribeSigma: 'Suscribirse a Sigma',
        stakedAmount: 'Margen',
        stakedAmount2: 'Período',
        stakedAmount3: 'Ganancias acumuladas',
        stakingTime: 'Hora de participación',
        maturityTime: 'Fecha de vencimiento',
        redeem: 'Canjear',
        renew: 'Renovar',
        autoRenewActive: 'Renovación automática activada',
        autoRenewInactive: 'Renovación automática desactivada',
        smartContract: 'Custodiado mediante contrato inteligente. El depósito permanece bloqueado durante un ciclo de 28 días y se desbloquea al finalizar.',
        alter2: 'Hay una suscripción vencida. Por favor, renuévala.'
    },

    me: {
        account: 'Cuenta',
        my: 'Mi cuenta',
        staked: 'Participó',
        staked1: 'Margen',
        points: 'Puntos',
        consecutive: 'Días consecutivos',
        withdraw: 'Retirar',
        language: 'Idioma',
        simplifiedChinese: 'Chino simplificado',
        disconnectWallet: 'Desconectar cartera',
        level: 'Nivel',
        joinDate: 'Fecha de registro',
        bdId: 'BD-ID'
    },

    bindapi: {
        apiBinding: 'Vinculación de API',
        bindDesc: 'Vincula la API de tu exchange para autorizar el trading cuantitativo.',
        apiKey: 'API Key',
        apiSecret: 'API Secret',
        exchange: 'Exchange',
        futures: 'Futuros',
        spot: 'Spot',
        readOnly: 'Solo lectura',
        bind: 'Vincular',
        riskNote: 'La clave API solo se utiliza para sincronizar los datos de trading. No se almacena información sensible.',
        apiConnection: 'Conexión API',
        bindExchangeApi: 'Vincular API del exchange',
        bitDeepRead: 'BitDeep lee el flujo de órdenes de tu cuenta CEX para verificar la Prueba de Operación Real (PoRT).',
        noWithdraw: 'Nunca tendremos acceso a tus retiros.',
        securityTip: 'Aviso de seguridad · Léelo atentamente',
        close: 'Cerrar',
        withdraw: 'Retirar',
        permission: 'Permisos',
        onlyEnable: 'Habilitar únicamente',
        spotTrading: 'Trading Spot',
        read: 'Lectura',
        recommendedPartner: 'Socio recomendado',
        zeroFee: '0 % de comisión',
        activated: 'Activado',
        classicAccount: 'Cuenta clásica',
        unifiedAccount: 'Cuenta unificada',
        bindBitgetApi: 'Vincular API de Bitget',
        upcoming: 'Próximamente',
        underAudit: 'Integración en proceso de auditoría',
        expected: 'Previsto'
    },
        port: {
        portTaskCenter: 'Centro de tareas PoRT',
        dailyTask: 'Tarea diaria',
        verify: 'Verificar',
        completed: 'Completada',
        incomplete: 'Incompleta',
        verifyStandard: 'Criterios de verificación',
        tradingVolume: 'Volumen de operaciones',
        today: 'Hoy',
        deadline: 'Hora límite',
        reward: 'Recompensa',
        startVerify: 'Iniciar verificación',
        verifying: 'Verificando',
        verified: 'Verificado',
        insufficient: 'No alcanzado',
        viewDetails: 'Ver detalles',
        taskList: 'Lista de tareas',
        allTasks: 'Todas las tareas',
        completedTasks: 'Tareas completadas',
        pendingTasks: 'Tareas pendientes',
        proofOfRealTrading: 'Prueba de Operación Real',
        todayTask: 'Tarea de hoy',
        todayStaticIncome: 'Recompensas de las tareas de hoy',
        points: 'Puntos',
        todayWindowClosesAt: 'La ventana de hoy finaliza a las',
        checkTaskStatus: 'Comprobar estado de la tarea',
        teamProgress: 'Progreso del equipo · Hoy',
        realtimePortCompletion: 'Estado de finalización de PoRT en tiempo real',
        completedText: 'Completado',
        pendingText: 'Pendiente',
        realtimeApiValidationFlow: 'Flujo de verificación de API · En tiempo real',
        rewardRemark1: 'Dividendos globales',
        rewardRemark2: 'Bonificación diferencial',
        rewardRemark3: 'Bonificación por recomendación',
        rewardRemark4: 'Recompensa por tarea',
        rewardRemark5: 'Tarea PoRT completada'
    },

    internet: {
        network: 'Red',
        treeBrowser: 'Explorador en árbol',
        searchAddress: 'Buscar dirección 0x... o BD-ID',
        totalTradingVolume: 'Volumen total de operaciones',
        members: 'miembros',
        networkStructure: 'Estructura de la red',
        allLevels: 'Todos los niveles',
        addRemark: 'Añadir nota',
        enterRemark: 'Introduzca una nota',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        alert1: 'Rendimiento por referidos directos',
        alert2: 'Rendimiento del equipo',
        alert3: 'Estado de la tarea'
    },

    withdraw: {
        withdraw: 'Retirar',
        usdtAsset: 'Activos en USDT',
        withdrawAmount: 'Importe del retiro',
        availableBalance: 'Saldo disponible',
        fee: 'Comisión',
        actualArrival: 'Importe recibido',
        submit: 'Enviar',
        withdrawSuccess: 'Completado',
        withdrawFailed: 'Fallido',
        processing: 'En proceso',
        completed: 'Completado',
        withdrawHistory: 'Historial de retiros'
    },
        popup: {
        taskUnfinished: 'Tarea no completada',
        taskUnfinishedDesc: 'Los datos de operación aún no cumplen los requisitos de verificación PoRT de hoy.',
        todayTradingVolume: 'Volumen de operaciones de hoy',
        remaining: 'Falta',
        toComplete: 'para completar la tarea de hoy',
        tradingVolumeThreshold: '',
        deadline: 'Tiempo restante hasta el cierre de la tarea',
        tryAgain: 'Vuelve a intentarlo más tarde',
        goTrade: 'Ir a operar',

        taskCompleted: 'Verificación de la tarea completada',
        taskCompletedDesc: 'La prueba de operación PoRT de hoy se ha registrado correctamente en la blockchain.',
        rewardIssued: 'Recompensa distribuida',
        complete: 'Completar',

        shareTitle: 'Invitar a amigos',
        shareDesc: 'Invita a tus amigos a registrarse y ambos recibiréis recompensas.',
        referralLink: 'Enlace de invitación',
        qrCode: 'Código QR',
        copyLink: 'Copiar enlace',

        notask: 'No hay tareas para hoy',
        notaskDesc: 'Actualmente no hay tareas PoRT pendientes.'
    }
};